import { render, staticRenderFns } from "./SkinsEdit.vue?vue&type=template&id=a5cfdf26&scoped=true&"
import script from "./SkinsEdit.vue?vue&type=script&lang=js&"
export * from "./SkinsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5cfdf26",
  null
  
)

export default component.exports